export default "__VITE_ASSET__dba2ff63__"